/* Wombshine: open header dropdowns on hover for mouse users so the parent
   label can stay a real link (click Shop -> /collections/all). The caret
   still toggles on click and keyboard; Craft's <header-menu> handles
   focus-out and animations. */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  document.querySelectorAll('.header__menu-parent').forEach(function (item) {
    var details = item.querySelector('header-menu > details');
    if (!details) return;
    var closeTimer;
    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      if (!details.open) details.open = true;
    });
    item.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        if (!item.contains(document.activeElement)) details.open = false;
      }, 180);
    });
  });
})();
